import { render, staticRenderFns } from "./3DPaymentSuccessfulFB.vue?vue&type=template&id=6d80c481&scoped=true"
import script from "./3DPaymentSuccessfulFB.vue?vue&type=script&lang=js"
export * from "./3DPaymentSuccessfulFB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d80c481",
  null
  
)

export default component.exports